import { combineReducers } from 'redux'

import itensPlano from './itensPlano'

export default combineReducers({ itensPlano })
